const currentDate = function currentDate(): Date {
  return new Date(Date.now());
};

export default currentDate;
